import React from 'react'
import Label from './Label'
import ErrorMessage from './ErrorMessage'
import ReactDatePicker from 'react-datepicker'
import { useFieldsLocked } from '../../contexts/ReadOnlyContext'

export default function DatePicker({
  error,
  label,
  name,
  noRightPadding,
  noLabelPadding,
  onBlur,
  onChange = () => {},
  optional,
  topMargin = 'mt-5',
  selected,
  customInput,
  dateFormat = 'yyyy-MM-dd',
  wrapperClassName = 'w-full',
  containerClassName = 'w-full',
  minDate,
  disabled = false,
}) {
  const fieldsLocked = useFieldsLocked()
  return (
    <div className={`${containerClassName} ${topMargin}`}>
      <Label label={label} noRightPadding={noRightPadding} noLabelPadding={noLabelPadding}/>

      <ReactDatePicker
        name={name}
        selected={selected}
        onChange={onChange}
        wrapperClassName={wrapperClassName}
        customInput={customInput}
        minDate={minDate}
        disabled={disabled || fieldsLocked}
        className={`w-full p-2 border-1 !ring-transparent !focus-within:border-rb-green !focus-within:border-2 rounded-lg dark:bg-rb-dark-mode dark:text-white dark:border-rb-dark-mode-lighter dark:placeholder-gray-400 ${error ? '!border-red-500' : '!border-rb-lite-grey'}`}
        dateFormat={dateFormat}
        showPopperArrow={false}
        popperClassName="react-datepicker-popper"
        popperPlacement="bottom-start"
        calendarClassName="react-datepicker"
        error={error}
        onBlur={onBlur}
      />

      {optional && <p className="optional-text">Optional</p>}
      {
        error && (
          <ErrorMessage text={error} />
        )
      }
    </div>
  )
}
